import { create } from 'zustand';

type State = {
  isOpen: boolean;
  focusDraftId?: string;
  openDrawer: (focusDraftId?: string) => void;
  closeDrawer: () => void;
};

export const useDraftMentionStore = create<State>((set) => ({
  isOpen: false,
  focusDraftId: undefined,
  openDrawer: (focusDraftId) => set({ isOpen: true, focusDraftId }),
  closeDrawer: () => set({ isOpen: false, focusDraftId: undefined }),
}));
